"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _propTypes = require("prop-types");

var _Error = _interopRequireDefault(require("./../Messages/Error"));

var _CheckBox_v = _interopRequireDefault(require("../v2/Checkboxes/CheckBox_v2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SearchSelectInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var async = _ref.async,
      className = _ref.className,
      onSelected = _ref.onSelected,
      dataTestId = _ref.dataTestId,
      loading = _ref.loading,
      loadOptions = _ref.loadOptions,
      options = _ref.options,
      name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      children = _ref.children,
      initial = _ref.initial,
      noOptionMessage = _ref.noOptionMessage,
      loadingMessage = _ref.loadingMessage,
      placeholder = _ref.placeholder,
      isMulti = _ref.isMulti,
      error = _ref.error,
      withCheckmark = _ref.withCheckmark,
      otherProps = _objectWithoutProperties(_ref, ["async", "className", "onSelected", "dataTestId", "loading", "loadOptions", "options", "name", "value", "disabled", "children", "initial", "noOptionMessage", "loadingMessage", "placeholder", "isMulti", "error", "withCheckmark"]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      isSelected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(option) {
    setSelected(option || []);

    if (!option) {
      onSelected({
        name: name,
        value: undefined
      });
      return;
    }

    onSelected({
      name: name,
      value: Array.isArray(option) ? option : option.value
    });
  };

  (0, _react.useEffect)(function () {
    if (loading || !options.length || options === []) {
      setSelected('');
    }

    if (initial) {
      setSelected(initial);
    }

    if (value) setSelected(value);
  }, [value, options, initial, loading]);

  var Option = function Option(_ref2) {
    var isSelected = _ref2.isSelected,
        value = _ref2.value,
        rest = _objectWithoutProperties(_ref2, ["isSelected", "value"]);

    Option.propTypes = {
      isSelected: _propTypes.bool,
      value: _propTypes.any
    };
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, rest, /*#__PURE__*/_react.default.createElement(Flex, null, /*#__PURE__*/_react.default.createElement(Checkbox, {
      checked: isSelected,
      onChange: function onChange() {
        return null;
      }
    }), ' ', /*#__PURE__*/_react.default.createElement("label", null, value), ' ')), ' ');
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Label, _extends({
    disabled: disabled
  }, otherProps), children, !async ? /*#__PURE__*/_react.default.createElement(Input, _extends({
    ref: ref,
    dataTestId: dataTestId,
    isDisabled: disabled,
    onChange: handleChange,
    name: name,
    options: options,
    value: isSelected,
    noOptionsMessage: function noOptionsMessage() {
      return noOptionMessage;
    },
    placeholder: loading ? loadingMessage : placeholder,
    classNamePrefix: "Select",
    isMulti: isMulti,
    closeMenuOnSelect: !isMulti,
    error: error ? true : false
  }, withCheckmark && {
    components: {
      Option: Option
    }
  }, withCheckmark && {
    hideSelectedOptions: false
  }, otherProps)) : /*#__PURE__*/_react.default.createElement(AsyncInput, _extends({
    ref: ref,
    dataTestId: dataTestId,
    isDisabled: disabled,
    onChange: handleChange,
    placeholder: loading ? loadingMessage : placeholder,
    classNamePrefix: "Select",
    isMulti: isMulti,
    name: name,
    closeMenuOnSelect: !isMulti,
    error: error ? true : false,
    cacheOptions: true,
    value: isSelected,
    loadOptions: loadOptions,
    defaultOptions: true
  }, withCheckmark && {
    components: {
      Option: Option
    }
  }, withCheckmark && {
    hideSelectedOptions: false
  }, otherProps))), /*#__PURE__*/_react.default.createElement(_Error.default, {
    error: error
  }));
});
var styles = (0, _styledComponents.css)(["width:100%;justify-self:center;position:relative;margin-top:0.8rem;margin-bottom:", ";span{border-color:", ";}&:focus{outline:", ";}& .Select{width:100%;&__control{border-radius:0.5rem;min-height:4.5rem;border:1px solid;border-color:", ";position:relative;:hover{border-color:#c1c1c1;}&--is-focused{border-color:", ";box-shadow:none;:hover{border-color:", ";}}}&__placeholder{color:#c1c1c1;}&__control--menu-is-open{&:hover{border-color:", ";}.Select__dropdown-indicator{& svg{transform:rotate(180deg);transition:0.1s ease;}}}&__value-container{padding:0 1.2rem;font-size:1.6rem;@media screen and (max-width:500px){font-size:1.4rem;}}&__single-value{color:black;overflow:visible;overflow:initial;}&__menu{font-size:1.6rem;box-shadow:none;top:3rem;border:1px solid #c1c1c1;border-top:none;border-radius:0 0 0.5rem 0.5rem;overflow:hidden;position:absolute;background:none;padding-top:0.8rem;}&__menu-list{max-height:16rem;background-color:white;&::-webkit-scrollbar{-webkit-appearance:none;}&::-webkit-scrollbar-thumb{border-radius:8px;border:2px solid white;background-color:#c7c7c7;}&::-webkit-scrollbar-track-piece{background:#f0f1f3;border-radius:5px;width:8px;border:2px solid white;}&::-webkit-scrollbar:vertical{width:12px;}&::-webkit-scrollbar:horizontal{height:8px;}}&__menu-notice--no-options,&__menu-notice--loading{min-height:4.8rem;display:flex;align-items:center;}&__option{background:white;padding:0.4rem 1.2rem;min-height:4.5rem;display:flex;align-items:center;cursor:pointer;border-bottom:1px solid #f0f1f3;&:last-of-type{border-bottom:none;}& .custom-option_primary-label{color:", ";font-size:1.6rem;}& .custom-option_secondary-label{font-size:1.2rem;}&:hover{background-color:#8990A3;}&--is-focused{background-color:#8990A3;}&--is-selected{background-color:white;& .custom-option_primary-label{color:", ";}& .custom-option_secondary-label{color:", ";}}}&__multi-value{background:rgba(255,128,0,0.05);border:1px solid ", ";box-sizing:border-box;border-radius:3px;&__label{color:", ";line-height:1.6rem;padding:0.2rem 0.2rem 0.2rem 0.4rem;box-sizing:border-box;}&__remove{cursor:pointer;& svg{fill:", ";}&:hover{background-color:initial;}}}}"], function (_ref3) {
  var error = _ref3.error;
  return error ? 0 : '2rem';
}, function (_ref4) {
  var theme = _ref4.theme,
      hasValue = _ref4.hasValue;
  return hasValue ? theme.brand.primary : '#C1C1C1';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
}, function (_ref6) {
  var theme = _ref6.theme,
      error = _ref6.error,
      touched = _ref6.touched;
  return error ? theme.status.error : touched & !error ? theme.status.succes : '#c1c1c1';
}, function (_ref7) {
  var theme = _ref7.theme,
      hasValue = _ref7.hasValue;
  return hasValue ? theme.brand.primary : '#C1C1C1';
}, function (_ref8) {
  var theme = _ref8.theme,
      hasValue = _ref8.hasValue;
  return hasValue ? theme.brand.primary : '#C1C1C1';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.ui.interactive;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typo.title;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.brand.primary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.brand.secondary;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.brand.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.brand.primary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.brand.primary;
});

var Flex = _styledComponents.default.div.withConfig({
  displayName: "Flex"
})(["display:flex;align-items:center;font-size:1.5rem;"]);

var Checkbox = (0, _styledComponents.default)(_CheckBox_v.default).withConfig({
  displayName: "Checkbox"
})(["margin-right:1rem;"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:flex;flex-direction:column;width:100%;box-sizing:border-box;font-family:", ";min-height:9rem;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.font;
});

var Label = _styledComponents.default.label.withConfig({
  displayName: "Label"
})(["display:flex;flex-direction:column;font-size:1.4rem;transition:0.2s;line-height:1rem;color:", ";"], function (_ref17) {
  var disabled = _ref17.disabled,
      theme = _ref17.theme;
  return disabled ? theme.ui.disabled : '#8990A3';
});

var Input = (0, _styledComponents.default)(_reactSelect.default).withConfig({
  displayName: "Input"
})(["", ";"], styles);
var AsyncInput = (0, _styledComponents.default)(_async.default).withConfig({
  displayName: "AsyncInput"
})(["", ";"], styles);
SearchSelectInput.displayName = 'SearchSelectInput';
SearchSelectInput.defaultProps = {
  async: false,
  disabled: false,
  loading: false,
  noOptionMessage: 'No options',
  options: [],
  loadingMessage: 'Loading...',
  placeholder: 'Choose your option',
  initial: null,
  isMulti: false,
  withCheckmark: false,
  otherProps: {},
  value: null
};
SearchSelectInput.propTypes = {
  dataTestId: _propTypes.string,
  async: _propTypes.bool,

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Returns name and value of selected */
  onSelected: _propTypes.func,

  /** Sets name of inputfield */
  name: _propTypes.string,

  /** if true input is disabled */
  disabled: _propTypes.bool,

  /** string with errormessage */
  error: _propTypes.any,

  /** label above the input */
  children: _propTypes.node,

  /** array of objects {value: 'test', label: 'Test'} */
  options: _propTypes.any,

  /** set true if options are loading */
  loading: _propTypes.bool,

  /** name that sets selected on load */
  loadOptions: _propTypes.func,

  /** If a checkmark should be showed if it is selected */
  withCheckmark: _propTypes.bool,

  /** Initial */
  initial: _propTypes.any,

  /** Message to show when options are empty */
  noOptionMessage: _propTypes.string,

  /** Message to show when loading is true */
  loadingMessage: _propTypes.string,

  /** Message to show on load when no initial */
  placeholder: _propTypes.string,

  /** Defines if it can handle multiple tags */
  isMulti: _propTypes.bool,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,

  /** Triggers when input is cleared */
  value: _propTypes.any
};
var _default = SearchSelectInput;
exports.default = _default;